import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <LoadingContainer>
      <LoadingText
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        Loading...
      </LoadingText>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0a192f;
`;

const LoadingText = styled(motion.h1)`
  color: #64ffda;
  font-family: 'Courier New', monospace;
`;

export default LoadingScreen;